// extracted by mini-css-extract-plugin
export default {"wrapper":"TertiarySwiper_wrapper__IDi6b","inner":"TertiarySwiper_inner__A6m6f","rowIcon":"TertiarySwiper_rowIcon__Hc4sZ","btns":"TertiarySwiper_btns__bCy7Y"};